import { CommonService } from 'api/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useGetCommonBrandsQueryKey = 'useGetCommonBrandsQueryKey';

export const useGetCommonBrandsQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof CommonService.getCommonBrands>>,
      QueryError,
      Awaited<ReturnType<typeof CommonService.getCommonBrands>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) => useQuery([useGetCommonBrandsQueryKey, ...(queryKey ?? [])], () => CommonService.getCommonBrands(), options);
